import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import singleUploadQuery from './singleUpload';
import CircularProgress from '@material-ui/core/CircularProgress';
import { toast } from 'react-toastify';

const UploadSingleFile = ({ onChange, children, id, sizeLimit = 2097152 /* 2MB */, ...props }) => {
  const [singleUpload, { loading }] = useMutation(singleUploadQuery);

  const onUpload = async ({ target }) => {
    if (!target.files) return;
    const files = Array.from(target.files);
    Promise.all(
      files.map(
        (file) =>
          new Promise((resolve, reject) => {
            if (file.size > sizeLimit) {
              return reject('File size is too big');
            }
            return resolve();
          })
      )
    )
      .then(() =>
        Promise.all(
          files.map(
            (file) =>
              new Promise((resolve) => {
                singleUpload({
                  variables: { file },
                  update: (cache, { data: { singleUpload } }) => {
                    resolve(singleUpload.url);
                  },
                });
              })
          )
        )
      )
      .then((urls) => {
        onChange(urls);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  return (
    <div className="flex-row">
      <input type="file" id={id} className="hide" multiple onChange={(e) => onUpload(e, singleUpload)} {...props} />
      <label htmlFor={id}>{children}</label>
      {loading && (
        <div className="px-2">
          <CircularProgress size={24} />
        </div>
      )}
    </div>
  );
};

export default UploadSingleFile;
